// extracted by mini-css-extract-plugin
module.exports = {"interactiveWrapper":"styles_interactiveWrapper__IFqWA","toggleWrapper":"styles_toggleWrapper__2aK_I","toggleText":"styles_toggleText__NR5bC"};